// Article Page
import Readmore from '../modules/Readmore'
import initProductSlider from '../modules/initProductSlider'
import addClickTabEvent from '../modules/addClickTabEvent'
import { activateTabs } from '../modules/activateTabs'

const handleDomLoaded = () => {
  addClickTabEvent()
  document
    .querySelectorAll('.js-productDetails-slider-container')
    .forEach((elm, index) => {
      elm.className += ` swiper-no${index}`
    })
  document.querySelectorAll('.js-swiper-pagenation').forEach((elm, index) => {
    elm.className += ` swiper-no${index}`
  })

  document
    .querySelectorAll('.js-productDetails-slider-container')
    .forEach((elm, index) => {
      initProductSlider(index)
    })
  Readmore.makeAll({
    containerSelector: '.js-collapsible-container',
    childrenSelector: 'ul li:nth-of-type(n + 2)',
    toggleButtonClass: 'c-productDetails__voiceList__moreList',
  })
  activateTabs()
}

window.addEventListener('DOMContentLoaded', handleDomLoaded, false)
